var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{staticClass:"short-button",class:_vm.classes,attrs:{"variant":_vm.variant || 'primary'},on:{"click":_vm.clicked}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }